import {
  FINANCE_ITEM_STATUSES,
  FINANCE_ITEM_TYPES,
  type FinanceItemStatuses
} from "../../../../constants/finance-item-constants.ts"
import { RESPONSIBLE_TYPES } from "../../../../constants/responsible-type-constants.ts"

// Mirrors FinancialTransactionItemCreateSerializer.create (counts_from_creation):
// a new line is stamped New, except a Reimbursement and a team member's
// payable, which count from the moment they are opened and so keep the
// Planned/Pending status implied by is_planned.
const countsFromCreation = (
  responsibleType: number | null | undefined,
  itemType: number | null | undefined
): boolean =>
  responsibleType === RESPONSIBLE_TYPES.REIMBURSEMENT ||
  (responsibleType === RESPONSIBLE_TYPES.TEAM_MEMBER &&
    itemType === FINANCE_ITEM_TYPES.PAYABLE)

export const statusOnCreate = (
  responsibleType: number | null | undefined,
  isPlanned: boolean | null | undefined,
  itemType?: number | null
): FinanceItemStatuses => {
  if (!countsFromCreation(responsibleType, itemType)) {
    return FINANCE_ITEM_STATUSES.NEW
  }
  return isPlanned
    ? FINANCE_ITEM_STATUSES.PLANNED
    : FINANCE_ITEM_STATUSES.PENDING
}
